export const apiConstants = {
  url: "/api/parent"
};
